import { EmitterConfigV3 } from '@pixi/particle-emitter';
import { Texture } from 'pixi.js';

const Particle: EmitterConfigV3 = {
  lifetime: {
    max: 0.7,
    min: 0.7,
  },
  particlesPerWave: 2,
  frequency: 0.008,
  spawnChance: 2,
  emitterLifetime: -1,
  maxParticles: 2000,
  pos: {
    x: 0,
    y: 0,
  },
  ease: [
    {
      s: 0,
      cp: 0.379,
      e: 0.548,
    },
    {
      s: 0.548,
      cp: 0.717,
      e: 0.676,
    },
    {
      s: 0.676,
      cp: 0.635,
      e: 1,
    },
  ],
  emit: false,
  behaviors: [
    {
      type: 'alpha',
      config: {
        alpha: {
          list: [
            {
              time: 0.5,
              value: 1,
            },
            {
              time: 1,
              value: 0.1,
            },
          ],
        },
      },
    },
    {
      type: 'scale',
      config: {
        scale: {
          list: [
            {
              value: 1,
              time: 0,
            },
            {
              value: 0.5,
              time: 1,
            },
          ],
        },
      },
    },
    {
      type: 'moveSpeed',
      config: {
        speed: {
          list: [
            {
              value: 4000,
              time: 0,
            },
            {
              value: 1000,
              time: 1,
            },
          ],
          isStepped: false,
        },
      },
    },
    {
      type: 'rotation',
      config: {
        accel: 0,
        minSpeed: 70,
        maxSpeed: 110,
        minStart: 70,
        maxStart: 110,
      },
    },
    {
      type: 'spawnShape',
      config: {
        type: 'rect',
        data: {
          x: 0,
          y: -10,
          w: 1080 * 3,
          h: 10,
        },
      },
    },
    {
      type: 'textureRandom',
      config: {
        textures: [
          Texture.from('/textures/etc/snow_1.png'),
          Texture.from('/textures/etc/snow_2.png'),
          Texture.from('/textures/etc/snow_2.png'),
        ],
      },
    },
  ],
};

export default Particle;
